import { createReducer, createActions } from "reduxsauce";

const { Types, Creators } = createActions({
    loadingRequest: ["isLoadingRequest"],
    loadingSearch: ["isLoadingSearch"],
    openConfirmModal: ["isOpenConfirmModal"],
});

export const INITIAL_STATE = {
    isLoadingRequest: false,
    isRequestFailed: false,
    isLoadingSearch: false,
    isOpenConfirmModal: false,
}

const loadingRequest = (state, { isLoadingRequest }) => {
    return {
        ...state,
        isLoadingRequest
    };
};

const loadingSearch = (state, { isLoadingSearch }) => {
    return {
        ...state,
        isLoadingSearch
    };
};

const openConfirmModal = (state, { isOpenConfirmModal }) => {
    return {
        ...state,
        isOpenConfirmModal
    };
};

export { Types as FormTypes };
export { Creators as formsActions };

export const reducer = createReducer(INITIAL_STATE, {
    [Types.LOADING_REQUEST]: loadingRequest,
    [Types.LOADING_SEARCH]: loadingSearch,
    [Types.OPEN_CONFIRM_MODAL]: openConfirmModal,
});
